<script>
import { eventBus } from "../main";
import navigation from "../mixins/navigation.js";
export default {
  mixins: [navigation],
  name: "app",
  data() {
    return {
      last: "P_8",
      next: "P_10",
      topic: "Taller ¿Qué es crédito? / ¿Que voy a aprender?",
      progress: false
    };
  }
};
</script>
<template lang="pug">
v-app(style='background: #FFFFFF !important;')
  v-container(fluid, grid-list-xl)
    v-content
      v-layout(row, justify-center)
        v-flex(xs12, sm12, md10, lg9, text-xs-center)
          v-card(flat)
            breadcrumb(:back='last')
            v-card-text.label16tt.withDivider(style='margin-top:-58px;')
              | TALLER ¿QUÉ ES CRÉDITO?
            v-card-text.titulo36Book
              | ¡Quiero saber qué es y para qué sirve un crédito!
            v-img(style='width:100%;', :src='require("@/assets/TCC-L3-Pagina1 A.png")')
            v-card-text.parrafoDestacado18.text-xs-left
              | La palabra crédito viene del latín creditum, que en español significa “creer”. El uso del crédito es bastante habitual. Podríamos decir que lo hemos usado aun sin saber que se trata de un crédito. El siguiente escenario te dará opciones sobre qué condiciones pondrías para prestar dinero.  
            v-btn.btn(justify-space-between, type='button', color='primary', @click.prevent="nextPage(next)")
              | Siguiente
          l-progress(:value='this.$parent.currentPage')

</template>


